import { updateObject } from '../utilities/JSUtil'
import * as actionTypes from './actionTypes'

const initialState = {
    response: null,
    errorMessage: null,
    count: 1
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.HANDLE_HTTP_RESPONSE:
            return updateObject(state, {
                response: action.data,
                httpAction: action.httpAction,
                errorMessage: null,
                count: state.count + 1,
                isLockError: false,
                isAuthError: false,
                isSystemError: false
            })

        case actionTypes.HANDLE_HTTP_ERROR_RESPONSE:
            return updateObject(state, {
                response: null,
                httpAction: action.httpAction,
                errorMessage: action.data.message,
                errorDescription: action.data.description,
                count: state.count + 1,
                isLockError: action.isLockError,
                isAuthError: action.isAuthError,
                isSystemError: action.isSystemError
            })

        case actionTypes.HANDLE_USER_LOGIN:
            return updateObject(state, {
                isAdmin: action.data.isAdmin,
                propertyList: action.data.propertyList,
                userFullName: action.data.userFullName,
                isLockError: false,
                isAuthError: false,
                isSystemError: false
            })
    }
    return state
}

export default reducer